import * as Sentry from '@sentry/gatsby'

Sentry.init({
  dsn: process.env.GATSBY_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration()],
  // let's tweak once recent INP issues have been investigated
  tracesSampleRate: 1.0,
})
